<h1 mat-dialog-title class="text-center border-bottom">Enter Password Pin</h1>
<mat-dialog-content class="p-0">
    <div class="d-flex flex-column border-bottom w-100">
        <div class="p-3 w-100 pin-pad">
            @for (p of digits; track $index) {
                <button
                    type="button"
                    class="button secondary small"
                    [class.hidden]="p === ''"
                    [disabled]="p === ''"
                    [value]="p"
                    [class.no-event]="pin.length === 4"
                    (click)="onPinEnter(p)"
                >
                    {{ p }}
                </button>
            }
        </div>

        <div class="p-3 border-top">
            <p class="p3 text-center m-0">
                <span class="lvl-2 fw-bold">Pin:</span>&nbsp;
                <span [innerHTML]="pin" [class.lvl-1]="!error" [class.lvl-warning]="error"></span>
            </p>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="d-flex align-items-center justify-content-between w-100">
        <button mat-icon-button (click)="onPinErase()" [disabled]="!pin.length">
            <i class="fa-solid fa-delete-left" aria-hidden="true"></i>
        </button>
        <button mat-icon-button (click)="onPinConfirm()" [disabled]="pin.length !== 4">
            <i class="fa-solid fa-check" aria-hidden="true"></i>
        </button>
    </div>
</mat-dialog-actions>
<app-close-dialog></app-close-dialog>
